import PropTypes from 'prop-types'
import OpponentAvailabilityListView from './OpponentAvailabilityListView'

const WeeklyCalendarListView = ({
  unplayedOpponents,
  opponentAvailability,
  processOpponentSlots,
  handleOpponentClick,
  hasUserOverlap,
  getMatchProposalForOpponent,
  getScheduledMatchForOpponent,
  pendingProposals,
  currentUserPlayerId,
  allMatches,
}) => (
  <div className="list-view">
    <OpponentAvailabilityListView
      opponents={unplayedOpponents.map((opponent) => {
        const rawSlots = opponentAvailability.filter((slot) => {
          if (
            slot == null ||
            slot.opponent_user_id == null ||
            opponent == null ||
            opponent.user_id == null
          ) {
            return false
          }
          const slotUid = parseInt(slot.opponent_user_id, 10)
          const oppUid = parseInt(opponent.user_id, 10)
          if (isNaN(slotUid) || isNaN(oppUid)) {
            return false
          }
          return slotUid === oppUid && slot.start_time && slot.end_time
        })
        const processedSlots = processOpponentSlots(rawSlots)

        return {
          ...opponent,
          slots: processedSlots,
        }
      })}
      onProposeMatch={handleOpponentClick}
      hasUserOverlap={hasUserOverlap}
      getMatchProposalForOpponent={getMatchProposalForOpponent}
      getScheduledMatchForOpponent={getScheduledMatchForOpponent}
      pendingProposals={pendingProposals}
      showEmptyState={true}
      emptyMessage="No upcoming availability"
      currentPlayerId={currentUserPlayerId}
      allMatches={allMatches}
      showAddButton={false}
      title="Opponent Availability"
    />
  </div>
)

WeeklyCalendarListView.propTypes = {
  unplayedOpponents: PropTypes.array.isRequired,
  opponentAvailability: PropTypes.array.isRequired,
  processOpponentSlots: PropTypes.func.isRequired,
  handleOpponentClick: PropTypes.func.isRequired,
  hasUserOverlap: PropTypes.func.isRequired,
  getMatchProposalForOpponent: PropTypes.func.isRequired,
  getScheduledMatchForOpponent: PropTypes.func.isRequired,
  pendingProposals: PropTypes.instanceOf(Set).isRequired,
  currentUserPlayerId: PropTypes.number.isRequired,
  allMatches: PropTypes.array.isRequired,
}

export default WeeklyCalendarListView
